module.exports = __webpack_public_path__ + "static/media/quem_somos_2021.45d8f3c5.png";